<template>
  <div class="hostList">
    <div class="top">
      <span class="first">新闻报道</span>
    </div>
    <div class="seg"></div>
    <div class="news-content">
      <ul>
        <li v-for="item in newsList" :key="item.id" class="article">
          <router-link :to="{
              name:'Hot',
              params:{
                id:item.id
              }
            }">
            <div class="hostList-content">
              <div class="hostList-img-wrapper">
                <img class="hostList-img" :src="item.picture" :alt="item.title"/>
              </div>
              <div class="hostList-info">
                <div>
                  <p style="font-size: .3rem; font-weight: bold;">{{item.title}}</p>
                </div>
              </div>
            </div>
          </router-link>
          <div class="seg"></div>
        </li>
        <li>
          <v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false"
                  @page-change="pageChange"></v-page>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import pageNation from './pageNation'

  export default {
    name: "HotList",
    data() {
      return {
        totalRow: 100,
        pageArr: [],
        newsList: [],
        seoList: [],
        pageNum: 1
      }

    },
    components: {
      pageNation
    },
    metaInfo() {
      return {
        title: this.seoList.column_title?`${this.seoList.column_title}-打造影视行业优秀的资源聚合服务平台`: '',
        meta: [{
          name: 'keywords',
          content: this.seoList.column_keywords|| ''
        },
          {
            name: 'description',
            content: this.seoList.column_description|| ''
          }]
      }
    },
    methods: {
      getSeo() {
        let seoApi = 'https://api.yopoo.cn/api/v1/visit?page=1&count=12&column=2'
        this.$http.get(seoApi)
          .then((res) => {
            this.seoList = res.data.metas
          }, err => {
            console.log(err)
          })
      },
      getnewData() {
        var newsListApi = 'https://api.yopoo.cn/api/v1/visit?page=1&count=6&column=2';
        this.$http.get(newsListApi, {
          params: {
            page: this.pageNum,
            count: 6,
            column: 2
          }
        }).then(res => {
            this.newsList = res.data.data
          },
          err => {
            console.log(err)
          }
        )
      },
      pageChange(pInfo) {
        pInfo.pageSize = 10
        //{pageNumber: 1, pageSize: 10}
        this.pageNum = pInfo.pageNumber
        //for example, do some http request, get new data and update totalRow property
        this.$http.get('https://api.yopoo.cn/api/v1/visit', {
          params: {
            page: this.pageNum,
            count: pInfo.pageSize,
            column: 2
          }
        }).then((res) => {
          this.newsList = res.data.data
          this.pageArr = res.data.pagination
          this.totalRow = this.pageArr.total
        }, (err) => {
          console.log(err)
        })


      },


    },
    beforeMount() {
      this.getSeo()
      // this.getnewData()
    }


  }
</script>

<style scoped>
  .top {
    padding: 0 0 0 .23rem;
    background: #fff;
  }

  .hostList {
    background: #fff;
  }

  .first {
    font-size: .32rem; /*rem*/
  }

  .hostList-img-wrapper {
    width: 1.65rem;
    height: 1.24rem;
  }

  .hostList-img {
    height: 100%;
    max-width: 100%;
  }

  .hostList-content {
    display: flex;
    align-items: center;
    padding: .20rem .23rem;
  }

  .hostList-info {
    flex: 1;
  }

  .news-content {

  }

  .hostList-info {
    margin-left: .11rem;
  }

  .article {
    padding-bottom: .20rem;

  }

  .seg {
    width: 100%;
    height: .20rem;
    background: #f3f3f3;

  }


</style>



// WEBPACK FOOTER //
// src/components/HotList.vue